<template>
  <div class="c-tabs-content">
    <Spin size="large" fix v-if="loading" />
    <Row>
      <Col :span="24" class="c-search">
        <!-- search -->
        <el-select
          v-model="query"
          :multiple-limit="5"
          multiple
          filterable
          allow-create
          default-first-option
          style="width: calc(100% - 70px)"
          placeholder="请搜索您的业务或关键词"
        >
        </el-select>
        <Button type="primary" style="margin-left: 8px" @click="search">搜索</Button>
      </Col>
      <Col :span="24">
        <div class="c-include-exclude">
          <el-popover v-model="popInclude" trigger="manual" placement="bottom-start">
            <Row :gutter="12" class-name="c-include-popver">
              <Col :span="24" class="c-input-box flex-box">
                <ElInput v-model="inputTagValue" placeholder="空格分隔,最多二十个,每个标签不超过10个字符" @keyup.enter.native="handlePress">
                  <ElSelect v-model="contains" slot="prepend" style="width: 80px">
                    <ElOption value="include" label="包含"></ElOption>
                    <ElOption value="exclude" label="不包含"></ElOption>
                  </ElSelect>
                  <span slot="append" style="padding: 0 8px" @click="add">添加</span>
                </ElInput>
              </Col>
              <Col :span="24" class="c-input-box">
                <div v-if="lenState" class="c-tags-content">
                  <Tag v-for="(tag, idx) in valueTags" :key="idx" :name="tag" closable @on-close="handleClose">{{ tag }}</Tag>
                  <a href="javascript:;" class="g-error-text c-tags-betch" @click="valueTags = []">清空</a>
                </div>
                <div v-if="err || err1" class="c-tags-err">
                  <span v-if="err">单个标签长度应在1~40个字符之间</span>
                  <span v-if="err1">标签最多20个</span>
                </div>
              </Col>
              <Col :span="24" style="margin-top: 10px">
                <ElButton type="primary" @click="asyncUpload">确定</ElButton>
                <ElButton type="default" @click="handleContain">取消</ElButton>
              </Col>
            </Row>
            <ElButton slot="reference" :style="{ margin: 0 }" @click="popInclude = true">包含/不包含关键词</ElButton>
          </el-popover>
          <div class="c-contains">
            <Tag v-if="includes.length" closable @on-close="includes = []">
              包含“{{ includes[0] }}”{{ includes.length > 1 ? `等${includes.length}个关键词` : '关键词' }}
            </Tag>
            <Tag v-if="excludes.length" closable @on-close="excludes = []">
              不包含“{{ excludes[0] }}”{{ excludes.length > 1 ? `等${excludes.length}个关键词` : '关键词' }}
            </Tag>
          </div>
        </div>
      </Col>
      <Col :span="24" class-name="c-table">
        <!-- table -->
        <el-table
          ref="table"
          class="common-el-table-styles"
          stripe
          border
          :height="419"
          :data="tableList"
          @sort-change="sortChange"
          @select="selectionChange"
          @select-all="selectAll"
        >
          <el-table-column type="selection" width="39"> </el-table-column>
          <el-table-column
            v-for="(col, id) in columns"
            :key="id"
            :prop="col.key"
            :label="col.title"
            :min-width="col.width"
            :sortable="col.sortable"
            :fixed="col.fixed"
            :show-overflow-tooltip="col.overflow"
            :formatter="col.format"
            :sort-orders="['descending', 'ascending', null]"
          >
            <template slot-scope="scope">
              <el-button
                type="text"
                v-if="col.key === 'control'"
                :disabled="disabled(scope.row.keyWord)"
                @click="$emit('on-add', [scope.row])"
                >添加</el-button
              >
              <span v-else>{{ scope.row[col.key] }}</span>
            </template>
          </el-table-column>
        </el-table>
      </Col>
      <Col :span="24" class="c-cate-page-warpper">
        <!-- page -->
        <Page :current="page" :total="total" :page-size="size" class-name="c-cate-page" size="small" show-total @on-change="changePage" />
      </Col>
    </Row>
  </div>
</template>
<script>
import { isArray, isEmpty, getByteLen } from '@/common/js/utils'
import { getRecmWord } from '@/api/baidu.model'

const columns = [
  {
    title: '意图词',
    key: 'keyWord',
    sortable: 'custom'
  },
  {
    title: '类型',
    key: 'type'
  },
  {
    title: '流量覆盖',
    key: 'hot',
    width: '82',
    sortable: 'custom'
  },
  {
    title: '操作',
    key: 'control'
  }
]

export default {
  name: '',
  props: {
    account: {
      type: [Number, String]
    },
    result: {
      type: Array,
      require: true
    }
  },
  computed: {
    lenState() {
      return this.valueTags.length
    },
    disabled() {
      return (keyword) => {
        return this.result.findIndex((ret) => ret === keyword) > -1
      }
    }
  },
  data() {
    return {
      loading: null,
      err: null,
      err1: null,
      popInclude: false, // 添加包含手动控制
      query: [],
      columns: columns,
      tableList: [],
      includes: [],
      excludes: [],
      contains: 'include',
      inputTagValue: '',
      valueTags: [],
      page: 1,
      size: 20,
      total: 0
    }
  },
  methods: {
    search() {
      this.searchKeyword()
    },
    searchKeyword(filter) {
      const query = { keywords: this.query }
      if (filter) Object.assign(query, filter)
      this.getData(query)
    },
    handleContain() {
      this.contains = 'include'
      this.inputTagValue = ''
      this.valueTags = []
      this.err = false
      this.err1 = false
      this.popInclude = false
    },
    add() {
      if (isEmpty(this.inputTagValue)) {
        this.err = true
        return
      }
      let tags = this.inputTagValue.split(' ')
      if (isArray(tags)) {
        if (tags.some((ret) => getByteLen(ret) > 40)) {
          this.err = true
          return
        }
        tags = tags.filter((ret) => ret && getByteLen(ret) <= 40 && !this.valueTags.includes(ret))
        const vals = this.contains === 'include' ? this.includes : this.excludes
        if (tags.length > 20 - vals.length) {
          this.err1 = true
          return
        }

        this.valueTags.push(...tags)
        this.inputTagValue = ''
      }
    },
    asyncUpload() {
      if (!this.valueTags.length) {
        this.$Message.error('请先添加关键词')
        return
      }

      if (this.contains === 'include') {
        const vals = this.valueTags.filter((ret) => !this.includes.includes(ret))
        this.includes.push(...vals)
      } else {
        const vals = this.valueTags.filter((ret) => !this.excludes.includes(ret))
        this.excludes.push(...vals)
      }
      this.handleContain() // 还原
    },
    handleClose(e, name) {
      const idx = this.valueTags.indexOf(name)
      this.valueTags.splice(idx, 1)
    },
    changePage(val) {
      this.page = val
      this.getData()
    },
    sortChange(column) {
      let orderName
      if (column.order === 'ascending') orderName = 'asc'
      else if (column.order === 'descending') orderName = 'desc'
      this.searchKeyword({ sort: column.prop, order: orderName })
    },
    selectionChange(selection, row) {
      const { keyWord } = row
      const check = selection.findIndex((ret) => ret.keyWord === keyWord) > -1
      if (!check) this.$emit('on-del', row)
      else this.$emit('on-add', selection)
    },
    selectAll(selection) {
      const check = Boolean(selection.length)
      if (!check) {
        // 取消
        this.tableList.forEach((ret) => {
          this.$emit('on-del', ret)
        })
      } else this.$emit('on-add', selection)
    },
    doLayout() {
      this.$nextTick(() => {
        this.$refs.table.doLayout()
      })
    },
    handlePress() {
      this.add()
    },
    getData(filter) {
      let params = {
        ad_account_id: this.account,
        pageIndex: this.page,
        pageSize: this.size
      }
      if (this.includes.length) Object.assign(params, { includes: this.includes })
      if (this.excludes.length) Object.assign(params, { excludes: this.excludes })

      if (filter) params = Object.assign(params, filter)
      else params = Object.assign(this.params, params)
      this.params = JSON.parse(JSON.stringify(params))
      this.loading = true

      getRecmWord(params)
        .then((data) => {
          this.loading = false
          if (!data) return
          const { list, page_info } = data
          if (isArray(list) && page_info) {
            const { total_number } = page_info
            this.total = total_number || 0
            this.tableList = list
            this.$nextTick(() => {
              this.RowSelection()
            })
          }
        })
        .catch(() => {
          this.loading = false
          this.total = 0
          this.tableList = []
        })
    },
    RowSelection() {
      if (!this.$refs.table) return
      this.$refs.table.clearSelection()
      this.result.forEach((ret) => {
        const idx = this.tableList.findIndex((met) => met.keyWord === ret)
        if (idx > -1) this.$refs.table.toggleRowSelection(this.tableList[idx], true)
      })
    }
  },
  watch: {
    includes() {
      this.params && this.getData()
    },
    excludes() {
      this.params && this.getData()
    },
    result: {
      handler(nVal) {
        if (isArray(nVal)) this.RowSelection()
      },
      deep: true
    }
  }
}
</script>
<style lang="scss" scoped>
.c-tabs-content {
  z-index: 1024;

  .ivu-spin-fix {
    z-index: 998;
  }

  .c-search {
    padding: 6px 0;
    display: flex;
    align-items: flex-end;
  }

  .c-include-exclude {
    padding: 4px 0 10px;
    display: flex;

    .c-include-popver {
      width: 520px;

      .c-input-box {
        padding: 0 5px;
        position: relative;
      }

      .c-tags-content {
        padding: 6px 12px;
        border: solid 1px #dee4f5;
        margin-top: 10px;

        .c-tags-betch {
          line-height: 22px;
          white-space: nowrap;
        }
      }

      .c-tags-err {
        margin-top: 10px;
        font-size: 14px;
        line-height: 28px;
        color: red;

        span {
          display: block;
        }
      }

      ::v-deep .ivu-input-group-append {
        cursor: pointer;
      }
    }

    .c-contains {
      padding: 5px 8px;
    }

    ::v-deep .ivu-tag {
      .ivu-icon-ios-close {
        margin-right: 0;
      }

      .ivu-tag-text {
        width: auto;
      }
    }
  }

  .c-cate-page-warpper {
    margin-top: 9px;

    .c-cate-page {
      float: right;
    }
  }
}

::v-deep .el-input__icon,
::v-deep .el-input__inner {
  line-height: 32px;
  height: 32px;
}
</style>
